import { ISessionStrategy } from 'src/types/module_types_authentication';
import { IHIHTTP } from 'src/types/hip_types';
import { Hosting } from 'src/core/ahp';
import tt from'../../../pip/library/pi-tt/pi-tt.js';

interface ITokenUserRecord {
  auth_token: string;
}

export class TokenDigestSessionStrategy implements ISessionStrategy {
  deactivate(ahp: Hosting) {
    // can we unhijack? hijack needs to give us a token of the previous function
    // issue: other methods could have been added since then
  }

  activate(ahp: Hosting) {
    window.HIP.aop.pointCut('hi-http', 'invoke', function (httpInvokeFn: Function) {
      return function (this: IHIHTTP, httpPayload: unknown) {
        const authTokenPath = ahp.session.configuration.account_token_path || '';
        const authToken: string = tt.get(`account.${authTokenPath}`, ahp.session) || '';

        if (authToken && authToken.length > 0) {
          this.headers = Object.assign(this.headers, {
            Authorization: `Token ${authToken}`
          });
        }

        return httpInvokeFn.call(this, httpPayload);
      };
    });
  }
}

export const tokenDigestSessionStrategy = new TokenDigestSessionStrategy();
